import TagManager from 'react-gtm-module';
import { isExpired } from 'react-jwt';
import { NavigateFunction } from 'react-router-dom';

import setTokenWithExpiry from 'utils/setTokenWithExpiry';

export interface LoginSuccessPayload {
  token: string;
  expiry?: string;
  user?: { id?: number | string };
  refresh_token?: string;
  refresh_token_expiry?: string;
}

export function persistLoginTokens(payload: LoginSuccessPayload) {
  setTokenWithExpiry(payload.token, payload.expiry);
  if (payload.refresh_token) {
    localStorage.setItem('BLOX_REFRESH_TOKEN', payload.refresh_token);
  }
  if (payload.refresh_token_expiry) {
    const refreshExpiry = new Date(payload.refresh_token_expiry.replace(/-/g, '/')).getTime();
    localStorage.setItem('BLOX_REFRESH_TOKEN_EXPIRY', JSON.stringify(refreshExpiry));
  }
}

export function completeLoginSession(options: {
  navigate: NavigateFunction;
  onAuthSuccess: (token: string, expiry: string) => void;
  payload: LoginSuccessPayload;
  /** When set, fires the same GTM login event as the main sign-in page. */
  gtmUserId?: number | string;
  showWelcomeScreen?: boolean;
}) {
  const { navigate, onAuthSuccess, payload, gtmUserId, showWelcomeScreen } = options;

  persistLoginTokens(payload);
  onAuthSuccess(payload.token, payload.expiry || '');

  if (gtmUserId != null) {
    TagManager.initialize({
      gtmId: 'GTM-NP7FL5N',
      events: {
        event: 'login',
        userId: gtmUserId,
      },
    });
  }

  const modelToken = window.localStorage.getItem('model-token');
  if (modelToken) {
    if (isExpired(modelToken)) {
      navigate('/home');
    } else {
      navigate(`/model/${modelToken}`);
    }
    localStorage.removeItem('model-token');
  } else if (showWelcomeScreen) {
    navigate('/welcome');
  } else {
    navigate('/home');
  }
}

/** Login response shape when MFA is required (fields depend on mfa_type). */
export interface LoginMfaChallengeResponse {
  mfa_required: true;
  mfa_type: string;
  setup_token?: string;
  cognito_access_token?: string;
  session?: string;
  user_id?: string | number;
}

export function isLoginMfaResponse(data: any): data is LoginMfaChallengeResponse {
  return Boolean(data?.mfa_required && data?.mfa_type);
}
